import { configureStore } from '@reduxjs/toolkit';
import {
  persistStore,
  persistReducer,
  
} from 'redux-persist';
import appReducer from './app/appSlice';
import { authReducer } from './auth/slice';
import { categoriesApi } from './category/categoriesApi';
import { shopsApi } from './shops/shopsApi';
import { bagsApi } from './bags/bagsApi';
import { calendarApi } from './calendar/calendarApi';
import storage from 'redux-persist/lib/storage';
import { faqApi } from './faq/faqApi';
import { financeApi } from './financial/financeApi';
import { settingsApi } from './settings/settingsApi';
import { documentsApi } from './documents/documentsApi';
import { ordersApi } from './orders/ordersApi';
import { statisticsApi } from './statistics/statisticsApi';
import { notificationApi } from './notification/notificationApi';
import { createTransform } from 'redux-persist';
import { menusApi } from './menus/menusApi';
import { optionsApi } from './options/optionsApi';
import { dishesApi } from './dishes/dishesApi';
import { groupsApi } from './groups/groupsApi';
import { dishordersApi } from './dishorders/dishordersApi';

const accessTransform = createTransform(
  (inboundState, key) => {
    return {
      token: inboundState.token,
      refreshToken: inboundState.refreshToken,
    };
  },
  (outboundState, key) => {
    return {
      token: outboundState.token,
      refreshToken: outboundState.refreshToken,
    };
  },
  { whitelist: ['access'] }
);

const authPersistConfig = {
  key: 'authM',
  storage,
  whitelist: ['access'],
  transforms: [accessTransform],
};

export const store = configureStore({
  reducer: {
       app: appReducer, 
    auth: persistReducer(authPersistConfig, authReducer),
    [categoriesApi.reducerPath]: categoriesApi.reducer,
    [shopsApi.reducerPath]: shopsApi.reducer,
    [bagsApi.reducerPath]: bagsApi.reducer,
    [calendarApi.reducerPath]: calendarApi.reducer,
    [faqApi.reducerPath]: faqApi.reducer,
    [financeApi.reducerPath]: financeApi.reducer,
    [settingsApi.reducerPath]: settingsApi.reducer,
    [documentsApi.reducerPath]: documentsApi.reducer,
    [ordersApi.reducerPath]: ordersApi.reducer,
    [statisticsApi.reducerPath]: statisticsApi.reducer,
    [notificationApi.reducerPath]: notificationApi.reducer,
    [menusApi.reducerPath]: menusApi.reducer,
    [groupsApi.reducerPath]: groupsApi.reducer,
    [optionsApi.reducerPath]: optionsApi.reducer,
    [dishesApi.reducerPath]: dishesApi.reducer,
    [dishordersApi.reducerPath]: dishordersApi.reducer,
  },

  middleware: getDefaultMiddleware => [
    ...getDefaultMiddleware({
      serializableCheck: false
    }),
    categoriesApi.middleware,
    shopsApi.middleware,
    bagsApi.middleware,
    calendarApi.middleware,
    faqApi.middleware,
    financeApi.middleware,
    settingsApi.middleware,
    documentsApi.middleware,
    ordersApi.middleware,
    statisticsApi.middleware,
    notificationApi.middleware,
    optionsApi.middleware,
    menusApi.middleware,
    dishesApi.middleware,
    groupsApi.middleware,
    dishordersApi.middleware
  ],
});

export const persistor = persistStore(store);
